import { watch } from 'vue'

import { useTeamStore } from '@/pinia/useTeamStore'
import { useInstructionsStore } from './useInstructionsStore'

export const useInstructionsLoader = (): void => {
  const teamStore = useTeamStore()
  const instructionsStore = useInstructionsStore()

  watch(
    () => teamStore.currentTeam?.id,
    (teamId): void => {
      if (!teamId) {
        return
      }

      instructionsStore.loadInstructions()
    },
    { immediate: true },
  )
}
